var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCross = function SvgCross(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    role: "img"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0E0075",
    d: "M12.2.9 8 5.2 3.8.9.9 3.8 5.2 8 .9 12.2l2.9 2.9L8 10.8l4.2 4.3 2.9-2.9L10.8 8l4.3-4.2z"
  })));
};
export default SvgCross;